export const getProductosFromStorage = () => {
    try {
        const productosData = localStorage.getItem('PRODUCTOS_TIENDA_ONLINE');
        if (!productosData) return [];

        let parsed;
        try {
            parsed = JSON.parse(productosData);
        } catch (parseError) {
            console.error('Error parsing JSON from localStorage:', parseError);
            return null;
        }

        if (Array.isArray(parsed)) return parsed; // Formato antiguo: array directo

        if (parsed && Array.isArray(parsed.items)) return parsed.items; // Formato nuevo: objeto con `items`

        console.warn('Unexpected productos format:', parsed);
        return []; // Fallback para formatos no válidos
    } catch (error) {
        console.error('Error reading productos from localStorage:', error);
        return null;
    }
};

export const saveProductosToStorage = (productos) => {
    try {
        // Ensure we're working with an array
        const itemsArray = Array.isArray(productos) ? productos : [];

        localStorage.setItem('PRODUCTOS_TIENDA_ONLINE', JSON.stringify({
            items: itemsArray,
            lastUpdated: new Date().toISOString()
        }));
    } catch (error) {
        console.error('Error saving productos to localStorage:', error);
    }
};